__webpack_require__.p = "/practice-with-react-typescript-for-kanban-board/";